import React from "react";

import { Box, Stack, Text, Wrap, Input, Tag } from "@chakra-ui/react";

import useStore from "../../../../store";
import useTranslations from "../../../../hooks/useTranslations";

import { AnswerReviewProps } from "./types/AnswerReviewProps";

const AnswerTimeSpentReview: React.FC<AnswerReviewProps> = React.memo(
  ({ answer, path }) => {
    const t = useTranslations();
    const viewer = useStore((state) => state.viewer);

    return (
      <Stack spacing="2">
        <Text fontSize="md" fontWeight="medium" color="gray.600">
          {t("reports.edit.timeSpentEvaluation")}
        </Text>
        {answer?.question?.expectedTimeValue && (
          <Wrap pb="4">
            <Tag variant="solid" colorScheme="purple">
              {t("reports.expectedTime.hours", {
                count: answer?.question?.expectedTimeValue,
              })}
            </Tag>
          </Wrap>
        )}
        <Box maxWidth="2xl" w="full">
          <Box
            as="label"
            htmlFor={`${path}.answer.${answer.id}.comment`}
            srOnly
          >
            {t("reports.edit.estimatedTimeSpentBy", {
              name: answer.user?.name,
            })}
          </Box>
          <Input
            id={`${path}.answer.${answer.id}.timespent`}
            isRequired={false}
            isInvalid={false}
            maxW="xs"
            _disabled={{ opacity: 1, cursor: "not-allowed" }}
            bgColor={answer.userId === viewer.id ? "gray.50" : "gray.100"}
            isDisabled
            color="darkBrand"
            value={
              t("reports.edit.hours", { count: answer?.timeSpent }) as string
            }
          />
        </Box>
      </Stack>
    );
  }
);

export default AnswerTimeSpentReview;
